import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";

import { AuthProvider } from "@mhj/shared/auth";
import App from "./App";

const container = document.getElementById("root");
if (!container) throw new Error("Root element not found");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Applicants are often on a weak connection; a failed fetch is usually
      // the network rather than a real error, so retry before giving up.
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(container).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 5000,
              style: {
                background: "#ffffff",
                color: "#171717",
                border: "1px solid #d8dbde",
                borderRadius: "14px",
                fontSize: "15px",
                maxWidth: "min(92vw, 460px)",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
